import React from 'react'

import { Field } from 'formik'

import { Row, Col, Form } from '_zari/core'

import * as CompaniaService from 'services/compania.service'

const AccesosSeriesTab = ({ companiasSeleccionadas }) => {
  const [companiasListadas, setCompaniasListadas] = React.useState([])

  React.useEffect(() => {
    CompaniaService.obtenerAsSelect().then(({ data }) => {
      setCompaniasListadas(data)
    })
  }, [])

  return (
    <Row>
      <Col md={12}>
        <table border='1' width='100%'>
          <thead>
            <tr>
              <th align='center'>COMPANIA</th>
            </tr>
          </thead>
          <tbody>
            {companiasListadas.map(x => (
              <tr key={x._id}>
                <td valign='top'>
                  <Field name='companias'>
                    {({ field }) => (
                      <Form.Checkbox
                        {...field}
                        id={`check-${x.razonSocial}`}
                        label={x.razonSocial}
                        value={x._id}
                        checked={companiasSeleccionadas.some(z => z === x._id)}
                      />
                    )}
                  </Field>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Col>
    </Row>
  )
}

export default React.memo(AccesosSeriesTab)
